import { Injectable } from '@angular/core';
import { ReportDesignerWidgetConfig } from '../models/report-designer-widget-config';

/**
 * Widget layout manager service
 */
@Injectable({
  providedIn: 'root'
})
export class WidgetLayoutManagerService {
  /**
   * Creates multidimensional array width * height with 0 on occupied spaces and 1 on free spaces
   * @param width Page width
   * @param height Page height
   * @param widgets Widgets on page for which page array is created
   * @returns Page array
   */
  public createPageArray(width: number, height: number, widgets: ReportDesignerWidgetConfig[]): number[][] {
    const pageArray: number[][] = [];
    //create empty page array (0 - free space)
    for (let y = 0; y < height; y++) {
      const emptyRowArray: number[] = [];
      pageArray.push(emptyRowArray);
      for (let x = 0; x < width; x++) {
        emptyRowArray.push(1);//free space
      }
    }

    //prepare page array (in Gridster2: col => x, row => y)
    for (const widget of widgets) {
      const col = widget.x,
        row = widget.y,
        sizeX = widget.cols,
        sizeY = widget.rows;

      for (let y = row, lenY = row + sizeY; y < lenY; y++) {
        const lenX = col + sizeX;
        for (let x = col; x < lenX; x++) {
          pageArray[y][x] = 0;//occupied space
        }
      }
    }

    return pageArray;
  }

  /**
   * Checks if there is space for widget in give page array
   * @param pageArray representong page
   * @param x Widget's X position 
   * @param y Widget's Y position 
   * @param widgetWidth Width of widget
   * @param widgetHeight Height of widget
   * 
   * @returns Can widgets with given position and dimension be placed on page
   */
  public checkFreeSpace(pageArray: number[][], x: number, y: number, widgetWidth: number, widgetHeight: number): boolean {
    if (x < 0 || y < 0) return false;

    const lenX = x + widgetWidth, lenY = y + widgetHeight;
    if (lenX > pageArray[0].length) return false;
    if (lenY > pageArray.length) return false;

    for (let i = x; i < lenX; i++) {
      for (let j = y; j < lenY; j++) {
        if (pageArray[j][i] === 0) {
          return false;
        }
      }
    }

    return true;
  }
}
